function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M155.114 72.2502V53.1633C155.114 50.04 152.586 47.508 149.468 47.508H16.234C13.1154 47.508 10.5874 50.04 10.5874 53.1633V72.2502H7.06005C6.40919 72.2502 5.76145 72.3403 5.13525 72.5181C1.38484 73.5828 -0.79371 77.4909 0.269329 81.2472L22.5049 159.816C22.9354 161.337 24.3219 162.387 25.9003 162.387H139.001C140.579 162.387 141.966 161.337 142.396 159.816L164.632 81.2472C164.809 80.62 164.899 79.9713 164.899 79.3194C164.899 75.4152 161.739 72.2502 157.841 72.2502H155.114Z",
  fill: "#F0F3F4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M153.898 43H23.4434C21.8647 43 20.4355 43.6409 19.401 44.677C18.3664 45.7132 17.7266 47.1446 17.7266 48.7257V101.436C17.7266 103.017 18.3664 104.448 19.401 105.484C20.4355 106.52 21.8647 107.161 23.4434 107.161H153.898C155.477 107.161 156.906 106.52 157.94 105.484C158.975 104.448 159.615 103.017 159.615 101.436V48.7257C159.615 47.1446 158.975 45.7132 157.94 44.677C156.906 43.6409 155.477 43 153.898 43Z",
  fill: "#E7F2F5",
  stroke: "#117A9B",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.368 50.8686C149.797 50.8686 151.766 52.8405 151.766 55.273L151.765 60.7653H160.933L160.934 95.7802C160.934 99.6722 157.784 102.827 153.898 102.827H23.4433C19.5574 102.827 16.4072 99.6722 16.4072 95.7802V60.7653H96.706L96.7067 55.273C96.7067 52.8405 98.6755 50.8686 101.104 50.8686H147.368Z",
  fill: "#F0F3F4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.236 57.8453C99.6257 57.8453 99.0733 58.093 98.6734 58.4936C98.2735 58.8941 98.0261 59.4474 98.0261 60.0586V67.7422H12.8801C12.3509 67.7422 11.8242 67.8155 11.3151 67.96C9.79035 68.3929 8.58516 69.4037 7.86919 70.6881C7.15322 71.9725 6.92646 73.5305 7.35864 75.0575L29.5942 153.627C29.729 154.103 30.0134 154.505 30.3877 154.789C30.762 155.072 31.2261 155.237 31.7203 155.237H144.821C145.248 155.237 145.696 155.04 146.08 154.75C146.472 154.453 146.804 154.045 146.966 153.564C152.104 138.337 154.275 129.691 156.445 121.045C157.537 116.697 158.629 112.349 160.094 107.173L169.183 75.0575C169.327 74.5476 169.4 74.0201 169.4 73.4901C169.4 71.9028 168.758 70.4659 167.719 69.4257C166.681 68.3855 165.246 67.7422 163.661 67.7422H150.447V60.0586C150.447 59.4474 150.2 58.8941 149.8 58.4936C149.4 58.093 148.847 57.8453 148.237 57.8453H100.236Z",
  fill: "white",
  stroke: "#117A9B",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.26 89.0423H49.9619C54.8193 89.0423 58.757 92.9862 58.757 97.8511V103.562C58.757 108.427 54.8193 112.371 49.9619 112.371H44.26C39.4026 112.371 35.4648 108.427 35.4648 103.562V97.8511C35.4648 92.9862 39.4026 89.0423 44.26 89.0423Z",
  fill: "#F0F3F4"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 69.2227,
  y1: 96.2795,
  x2: 141.861,
  y2: 96.2795,
  stroke: "#117A9B",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 69.2227,
  y1: 106.85,
  x2: 123.391,
  y2: 106.85,
  stroke: "#117A9B",
  strokeWidth: 3,
  strokeLinecap: "round"
});

const SvgSurveyEmpty = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 184,
  height: 184,
  viewBox: "0 0 184 184",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _ref), _ref2, /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _ref3), _ref4, _ref5, _ref6, _ref7));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSurveyEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/survey-empty.60272bbc.svg";
export { ForwardRef as ReactComponent };